import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-eb4b43d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "illustration"
}, " 💁 ", -1));
const _hoisted_3 = {
  class: "text"
};
const _hoisted_4 = {
  class: "line"
};
const _hoisted_5 = {
  class: "label"
};
const _hoisted_6 = {
  class: "value"
};
const _hoisted_7 = {
  class: "line"
};
const _hoisted_8 = {
  class: "label"
};
const _hoisted_9 = {
  class: "value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CenterTop = _resolveComponent("CenterTop");
  return _openBlock(), _createBlock(_component_CenterTop, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('helpVersion.version.front')) + ":", 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.versionFront), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('helpVersion.version.back')) + ":", 1), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.versionBack), 1)])])])]),
    _: 1
  });
}